import AuthApi from '@/services/api/auth-api'

const state = {
  profile: {},
  profile_only: {}
};

const getters = {
  profile(state: { profile: any }) {
    return state.profile
  },
  profile_only(state: { profile_only: any }) {
    return state.profile_only
  }
}

const actions = {
  FETCH_PROFILE(context: { commit: (arg0: string, arg1: any) => void }) {
    AuthApi.fetchProfile().then((response) => {
      context.commit('SET_PROFILE', response)
    })
  },
  FETCH_PROFILE_ONLY(context: { commit: (arg0: string, arg1: any) => void }) {
    AuthApi.profileOnly().then((response) => {
      context.commit('SET_PROFILE_ONLY', response)
    })
  }
}

const mutations = {
  SET_PROFILE(state: { profile: any }, payload: any) {
    state.profile = payload
  },
  SET_PROFILE_ONLY(state: { profile_only: any }, payload: any) {
    state.profile_only = payload
  }
}

export default {
  namespace: true,
  state,
  actions,
  mutations,
  getters
}
